var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" auth-v2"},[_c('div',{staticClass:"auth-inner"},[(_vm.assistances && _vm.assistances.length)?_c('assistenze-table',{attrs:{"assistances":_vm.assistances,"refresh":_vm.refresh}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }